/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserHotelStayDeleteRequest
 */
export interface UserHotelStayDeleteRequest {
    /**
     * 
     * @type {string}
     * @memberof UserHotelStayDeleteRequest
     */
    hotelStayId: string;
}

/**
 * Check if a given object implements the UserHotelStayDeleteRequest interface.
 */
export function instanceOfUserHotelStayDeleteRequest(value: object): value is UserHotelStayDeleteRequest {
    if (!('hotelStayId' in value) || value['hotelStayId'] === undefined) return false;
    return true;
}

export function UserHotelStayDeleteRequestFromJSON(json: any): UserHotelStayDeleteRequest {
    return UserHotelStayDeleteRequestFromJSONTyped(json, false);
}

export function UserHotelStayDeleteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserHotelStayDeleteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'hotelStayId': json['hotel_stay_id'],
    };
}

export function UserHotelStayDeleteRequestToJSON(json: any): UserHotelStayDeleteRequest {
    return UserHotelStayDeleteRequestToJSONTyped(json, false);
}

export function UserHotelStayDeleteRequestToJSONTyped(value?: UserHotelStayDeleteRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hotel_stay_id': value['hotelStayId'],
    };
}

